import createCrudModule from '@/utils/createCrudModule'

export default createCrudModule({
  resource: 'projectWorkspaceUsers',
  urlRoot: '/project_workspace_users'
})
